import { createBrowserRouter } from 'react-router-dom';

import { AnonymousRoute } from '../components';
import Entry from '../pages/Entry';
import QrCodeRedirect from '../pages/Entry/QrCodeRedirect';
import PropertyMap from '../pages/PropertyMap';
import VirtualDirectory from '../pages/VirtualDirectory';
import Visitor from '../pages/Visitor';
import VendorAccess from '../pages/VendorAccess';

export const browserRouter = createBrowserRouter([
  {
    path: '/visitor/:userRoleId',
    element: <AnonymousRoute children={<Visitor />} policy="GET_TOKEN" />,
  },
  {
    path: '/entry/:accessPointId',
    element: <AnonymousRoute children={<QrCodeRedirect />} policy="RENEW_TOKEN" />,
  },
  {
    path: '/property-directory/:accessPointId',
    element: <AnonymousRoute children={<VirtualDirectory />} policy="REQUIRE_TOKEN" />,
  },
  {
    path: '/qr/:accessPointId',
    element: <AnonymousRoute children={<Entry />} policy="REQUIRE_TOKEN" />,
  },
  {
    path: '/property/:propertyId',
    element: <PropertyMap />,
  },
  {
    path: '/vendor/:accessPointId',
    element: <AnonymousRoute children={<VendorAccess />} policy="REQUIRE_TOKEN" />,
  },
]);
